import {BUSCAR_AGENDAMENTOS_VIAGENS, LIMPAR_AGENDAMENTOS_VIAGENS } from '../../actions/types'

const initialState = undefined;

export default function reducerAgendamentosViagens (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_AGENDAMENTOS_VIAGENS: {
      const agendamnetos = action.payload.data;

      if (agendamnetos) {
        return agendamnetos
      }
      return []
    }

    case LIMPAR_AGENDAMENTOS_VIAGENS:
      return [];

    default: {
      return state
    }
  }
}
